module.exports = __webpack_public_path__ + "media/images/athletes/3557-fa6a3247171c165a45b0019da9318aa4.png";